import { Button, Modal } from 'react-bootstrap';
import React from "react";
import { connect } from 'react-redux';
import * as orderStatuses from '../../constants/orderStates';
import { taxiClasses } from '../../constants/taxiClasses';
import * as fetchingState from '../../constants/fetchingState';
import { reduxForm } from 'redux-form';
import moment from 'moment';

let OrderFullInfo = class extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {orderInfo, onClose, show, fetching} = this.props;

        const tableHeader = (history) => {
                return (<table className="table table-hover">
                <thead>
                    <tr>
                        <td></td>
                        <td>Дата изменения(UTC)</td>
                        <td>Пользователь</td>
                        <td>Статус</td>
                        <td>Время забора</td>
                        <td>Время возврата</td>
                        <td>Сейчас</td>
                        <td>Тип такси(забор)</td>
                        <td>Тип такси(возврат)</td>
                        <td>Комментарий</td>
                        <td>Отдел</td>
                        <td>Альтернативная оплата</td>
                        <td>Id адреса клиента</td>
                        <td>Адреса клиента</td>
                        <td>Геоточка адреса клиента</td>
                    </tr>
                </thead>
                <tbody>
                    {history.map(h => renderOrderHistory(h))}
                </tbody>
            </table>);
        };
        const renderOrderHistory = (orderHistory) => {
            const pickupTaxiClass = taxiClasses.find(t => t.Id == orderHistory.PickupTaxiClass);
            const offloadTaxiClass = taxiClasses.find(t => t.Id == orderHistory.OffloadTaxiClass);
            const clientGeoAddress = orderHistory.GeoPoint != null
                ? `${orderHistory.GeoPoint.X}, ${orderHistory.GeoPoint.Y}`
                : '';
            const state = orderStatuses.states.find(s => s.Id == orderHistory.State);
            return (
                    <tr key={orderHistory.Id}>
                        <td>{orderHistory.Id}</td>
                        <td>{orderHistory.ChangedAt ? moment(orderHistory.ChangedAt).format('DD.MM.YYYY HH:mm:ss') : ''}</td>
                        <td>{orderHistory.ChangedBy != null ? orderHistory.ChangedBy.Id : ''}</td>
                        <td>{state != null ? state.Name : ''}</td>
                        <td>{orderHistory.PickupDate ? moment(orderHistory.PickupDate).format('DD.MM.YYYY HH:mm:ss') : ''}</td>
                        <td>{orderHistory.OffloadDate ? moment(orderHistory.OffloadDate).format('DD.MM.YYYY HH:mm:ss') : ''}</td>
                        <td>{orderHistory.IsPickupNow === true ? 'Да' : 'Нет'}</td>
                        <td>{pickupTaxiClass != null ? pickupTaxiClass.Name : ''}</td>
                        <td>{offloadTaxiClass != null ? offloadTaxiClass.Name : ''}</td>
                        <td>{orderHistory.Comment}</td>
                        <td>{orderHistory.DcDepartmentId != null ? orderHistory.DcDepartmentId : ''}</td>
                        <td>{orderHistory.UseAlternativePayment === true ? 'Да' : 'Нет'}</td>
                        <td>{orderHistory.PickupAddressId != null ? orderHistory.PickupAddressId : ''}</td>
                        <td>{orderHistory.PickupAddress != null ? orderHistory.PickupAddress : ''}</td>
                        <td>{clientGeoAddress}</td>
                    </tr>);
        };

        const deliveryHeader = (delivery) => {
            return (<table className="table table-hover">
                <thead>
                    <tr>
                        <td></td>
                        <td>Дата создания(UTC)</td>
                        <td>Доставка клиенту</td>
                        <td>Id исходной точки</td>
                        <td>Адрес исходной точки</td>
                        <td>Геоточка исходной точки</td>
                        <td>Id точки назначения</td>
                        <td>Адрес точки назначения</td>
                        <td>Геоточка точки назначения</td>
                        <td>Статус</td>
                        <td>Цена</td>
                    </tr>
                </thead>
                <tbody>
                    {delivery.map(d => renderDelivery(d))}
                </tbody>
            </table>);
        }

        const renderDelivery = (delivery) => {
            return (
                    <tr key={delivery.Id}>
                        <td>{delivery.Id}</td>
                        <td>{delivery.CreationDate != null ? moment(delivery.CreationDate).format('DD.MM.YYYY HH:mm:ss') : ''}</td>
                        <td>{delivery.IsOffload === true ? 'Да' : "Нет"}</td>
                        <td>{delivery.SourceAddressId ? delivery.SourceAddressId : ''}</td>
                        <td>{delivery.SourceAddress ? delivery.SourceAddress : ''}</td>
                        <td>{delivery.SourceGeoAddress ? `${delivery.SourceGeoAddress.X}, ${delivery.SourceGeoAddress.Y}` : ''}</td>
                        <td>{delivery.DestinationAddressId ? delivery.DestinationAddressId : ''}</td>
                        <td>{delivery.DestinationAddress ? delivery.DestinationAddress : ''}</td>
                        <td>{delivery.DestinationGeoAddress ? `${delivery.DestinationGeoAddress.X}, ${delivery.DestinationGeoAddress.Y}` : ''}</td>
                        <td>{delivery.State}</td>
                        <td>{delivery.Price}</td>
                    </tr>);
        };

        return (
            <Modal show={show} dialogClassName='fullScreenModal'>
                <Modal.Header>
                    <Modal.Title>
                        <span>Заказ {orderInfo != null ? orderInfo.Id : ''}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {fetching == fetchingState.FETCHED && <div>
                            {tableHeader(orderInfo.History)}
                            <p></p>
                            {deliveryHeader(orderInfo.Delivery)}
                        </div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" onClick={() => onClose()}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapToProps(state, props) {
    
    return { };
}

OrderFullInfo = reduxForm({ form: 'OrderFullInfo' })(OrderFullInfo);

OrderFullInfo = connect(mapToProps, { })(OrderFullInfo);

export default OrderFullInfo;


// WEBPACK FOOTER //
// ./src/components/orders/OrderFullInfo.jsx